/** @format */

import React, { useEffect } from 'react';
import { PageContainer, Icons } from 'components';
import { CommonProvider } from 'providers';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Content from './components/Content';
import Serivces from '../services/Serivces';
import { useParams, useLocation } from 'react-router-dom';
import FunderSeparateReportSummary from './components/FunderSeparateReportSummary';
import useCustomHook from '../hooks';
import { constBreadCrumbsTitle } from 'utility';

const FunderTransAction = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const {
    loading,
    setLoading,
    funderData,
    setFunderData,
  } = useCustomHook();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const username = searchParams.get('userName');
    getFunder(username);
  }, []);
  const getFunder = (u) => {
    let obj = {
      offset: 0,
      size: 1,
      username: u,
    };
    Serivces.getFunders(obj)
      .then((res) => {
        setFunderData(res?.result[0]);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

 
  return (
    <>
      <PageContainer
        title={'صورت حساب تنخواه دار ' + (funderData?.userId || params?.id)}
        loading={loading}
        breadcrumbs={constBreadCrumbsTitle.FUNDER_TRANSACTIONS}
        meta={
          <Button
            // className={classes.cardHeaderButton}
            onClick={() => navigate(-1)()}
            color="primary"
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
            variant="outlined"
          >
            بازگشت
          </Button>
        }
      >
        <CommonProvider>{<Content userId={funderData?.userId} data={funderData} />}</CommonProvider>
      </PageContainer>
      <>
        <FunderSeparateReportSummary id={funderData?.userId || params?.id} />
      </>
    </>
  );
};

export default FunderTransAction;
